class Settings {
    claimr_lib_url;
    organization_tag;
    campaign_tag;

    constructor() {
        if (process.env.REACT_APP_ENV === 'LOCAL' || process.env.REACT_APP_ENV === 'DEV') {
            this.claimr_lib_url = 'https://dev.widgets.claimr.io/dev.claimr.min.js';
            this.organization_tag = 'claimr.io';
            this.campaign_tag = 'telegram-mini-app';
        } else {
            this.claimr_lib_url = 'https://widgets.claimr.io/claimr.min.js';
            this.organization_tag = 'claimr';
            this.campaign_tag = 'telegram-mini-app';
        }
    }
}

const settings = new Settings();

export default settings;
